export const IBPSWeightUnits = [
  {
    code: 'KGS',
    name: 'KILOGRAMS',
    title: 'policies.proposal.flow.questionnaire-step.lifestyle.kilogram',
    rate: 1,
  },
  {
    code: 'LBS',
    name: 'POUNDS',
    title: 'policies.proposal.flow.questionnaire-step.lifestyle.pounds',
    rate: 0.45359237,
  },
];

export const IBPSHeightUnits = [
  {
    code: 'CMS',
    name: 'CENTIMETERS',
    title: 'policies.proposal.flow.questionnaire-step.lifestyle.cm',
    rate: 1,
  },
  {
    code: 'INCHS',
    name: 'INCHES',
    title: 'policies.proposal.flow.questionnaire-step.lifestyle.inch',
    rate: 2.54,
  },
];
